module.exports = __webpack_public_path__ + "static/media/godaddySecure.b0bcb68d.png";